import { isNativeShell } from './platform.js';

/**
 * Endereços dentro de um texto de conversa viram toque (https e http; "www." sem o
 * protocolo também). A pontuação que cola no fim da frase fica fora do link.
 */
const URL_IN_TEXT = /\b(?:https?:\/\/|www\.)[^\s<>"'`]+/gi;
const TRAILING = /[.,;:!?)\]}]+$/;

export type LinkPart = { text: string; url?: string };

export function splitLinks(text: string): LinkPart[] {
  const parts: LinkPart[] = [];
  let last = 0;
  for (const match of text.matchAll(URL_IN_TEXT)) {
    const start = match.index ?? 0;
    const raw = match[0];
    const clean = raw.replace(TRAILING, '');
    if (clean.length < 5) continue;
    if (start > last) parts.push({ text: text.slice(last, start) });
    parts.push({ text: clean, url: clean.startsWith('www.') ? `https://${clean}` : clean });
    last = start + clean.length;
  }
  if (last < text.length) parts.push({ text: text.slice(last) });
  return parts.length > 0 ? parts : [{ text }];
}

/** Abre fora do app (navegador do aparelho), nunca dentro da conversa. */
export function openLink(url: string): void {
  window.open(url, isNativeShell() ? '_system' : '_blank', 'noopener,noreferrer');
}
